import * as React from 'react'
import { api } from '../lib/api'
import Markdown from 'markdown-to-jsx'
import Card from '@mui/joy/Card'
import Chip from '@mui/joy/Chip'
import Table from '@mui/joy/Table'
export default function ApplicationDetail({ id }: { id: string }) {
  const [data, setData] = React.useState<any>(null)
  React.useEffect(() => {
    api('/applications/' + id).then(setData)
  }, [id])
  if (!data) return <div className="p-6">Loading…</div>
  return (
    <div className="max-w-5xl mx-auto p-6 space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-semibold">Application</h2>
          <div className="text-sm opacity-70">{data.status}</div>
        </div>
        <Chip variant="soft">{data.status}</Chip>
      </div>
      {data.result && (
        <Card variant="outlined">
          <div className="font-semibold mb-2">Candidate Score: {data.result.totalScore}/100</div>
          <Table size="sm" variant="outlined">
            <thead>
              <tr>
                <th>Metric</th>
                <th className="text-right">Score</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(data.result.rubric || {}).map(([k, v]) => (
                <tr key={k}>
                  <td className="capitalize">{k}</td>
                  <td className="text-right font-semibold">{String(v)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="prose dark:prose-invert mt-4">
            <h4>Employer Summary</h4>
            <Markdown>{data.result.summaryEmployerMd || ''}</Markdown>
          </div>
        </Card>
      )}
      <Card variant="outlined">
        <div className="font-semibold">Transcript</div>
        <Transcript sessionId={data.session?.id} />
      </Card>
    </div>
  )
}
function Transcript({ sessionId }: { sessionId: string }) {
  const [msgs, setMsgs] = React.useState<any[]>([])
  React.useEffect(() => {
    if (sessionId) api(`/interview/sessions/${sessionId}/transcript`).then(setMsgs)
  }, [sessionId])
  if (!sessionId) return <div>No interview session.</div>
  return (
    <div className="mt-2 space-y-2">
      {msgs.map((m: any) => (
        <div key={m.id} className={'fade-in ' + (m.sender === 'agent' ? '' : 'text-right')}>
          <span
            className={
              'inline-block px-3 py-2 rounded-2xl ' +
              (m.sender === 'agent' ? 'bg-zinc-200 dark:bg-zinc-800' : 'bg-blue-600 text-white')
            }
          >
            {m.content}
          </span>
        </div>
      ))}
    </div>
  )
}
